<template>
    <v-layout column align-start>
        <span v-if="!!desc"> {{ desc }} </span>
        <span v-if="!!coda"> {{ coda }} </span>
        <template v-if="(isUserEmployee || isUserEmployer) && !isOnline">
            <expo-employer-map
                v-bind="{
                    employer: item.employer,
                }"
            >
                <template #activator="{ attrs, on }">
                    <v-btn small height="28" color="kakao" class="px-8 mt-10" v-bind="attrs" v-on="on">
                        <v-icon size="20" color="kakao-marker" class="ml-n2">mdi-map-marker</v-icon>
                        <span> 카카오맵 확인 </span>
                    </v-btn>
                </template>
            </expo-employer-map>
        </template>
    </v-layout>
</template>

<script>
import { initExpoMatching } from "@/assets/variables";

import ExpoEmployerMap from "@/components/client/expo/employer/expo-employer-map.vue";

export default {
    components: {
        ExpoEmployerMap,
    },
    props: {
        item: { type: Object, default: initExpoMatching },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    computed: {
        isOnline() {
            return this.item?.employer?.interview?.isOnline;
        },
        desc() {
            let type = this.isOnline ? "온라인" : "오프라인";

            let time = this.item?.interviewAt?.toDateTime?.();

            return `${type} 면접일시: ${time}`;
        },
        coda() {
            if (this.item.isGranted !== true) return;
            if (!(this.isUserEmployee || this.isUserEmployer)) return;

            if (this.isOnline) return "해당 시각에 온라인면접 버튼을 클릭해주세요.";
            else {
                let { location } = this.item?.employer?.interview || {};
                return `오프라인 면접장소: ${location}`;
            }
        },
    },
};
</script>

<style>
</style>